<template>
  <div class="pay-method-selector">
    <PayMethodCard
      v-for="method in onlineMethods"
      :key="method.key"
      :method="method.key"
      :selected="value === method.key"
      :disabled="isDisabled(method.key)"
      :show-icon="true"
      :title="method.title"
      :desc="method.desc"
      :icon-type="method.iconType"
      :tags="method.tags"
      @click="select(method.key)"
    />
    <PayMethodCard
      v-if="codEnabled"
      :method="PAY_METHOD.COD"
      :selected="value === PAY_METHOD.COD"
      :disabled="isDisabled(PAY_METHOD.COD)"
      :show-icon="true"
      :title="$t('orderPage.codOptionTitle')"
      :desc="$t('orderPage.codOptionDesc')"
      accent="#FF7A00"
      @click="select(PAY_METHOD.COD)"
    />
    <PayMethodCard
      v-if="storeEnabled"
      :method="PAY_METHOD.STORE"
      :selected="value === PAY_METHOD.STORE"
      :disabled="isDisabled(PAY_METHOD.STORE)"
      :show-icon="true"
      :title="$t('orderPage.storeOptionTitle')"
      :desc="$t('orderPage.storeOptionDesc')"
      :recommended="true"
      :recommended-text="$t('orderPage.storePickupOnly')"
      icon-type="store"
      @click="select(PAY_METHOD.STORE)"
    />
  </div>
</template>

<script>
import PayMethodCard from '@/components/PayMethodCard.vue';
import { PAY_METHOD } from '@/common/constants';

export default {
  name: 'PayMethodSelector',
  components: {
    PayMethodCard
  },
  props: {
    value: {
      type: String,
      default: PAY_METHOD.ONLINE
    },
    codEnabled: {
      type: Boolean,
      default: true
    },
    storeEnabled: {
      type: Boolean,
      default: false
    },
    onlineMethods: {
      type: Array,
      default: () => []
    },
    disabledMethods: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.applyDefaultSelection();
      }
    },
    onlineMethods: {
      immediate: true,
      deep: true,
      handler() {
        this.applyDefaultSelection();
      }
    }
  },
  data() {
    return {
      PAY_METHOD
    }
  },
  methods: {
    isSelectionValid(method) {
      if (!method) return false;
      if (method === PAY_METHOD.COD) {
        return this.codEnabled;
      }
      if (method === PAY_METHOD.STORE) {
        return this.storeEnabled;
      }
      return this.onlineMethods.some(item => item.key === method);
    },
    applyDefaultSelection() {
      if (this.isSelectionValid(this.value)) return;
      const firstMethod = this.onlineMethods[0]?.key;
      if (!firstMethod || this.value === firstMethod) return;
      this.$emit('update:value', firstMethod);
      this.$emit('change', firstMethod);
    },
    isDisabled(method) {
      return this.disabledMethods.includes(method);
    },
    select(method) {
      if (this.isDisabled(method)) return;
      this.$emit('update:value', method);
      this.$emit('change', method);
    }
  }
}
</script>
